import getDesignDataForExport from 'editor/src/store/design/selector/getDesignDataForExport';
import calculateDesignDataWarnings from 'editor/src/store/editorModules/warnings/utils/calculateDesignDataWarnings';
import { extendedWarningsToExportedWarnings } from 'editor/src/store/editorModules/warnings/utils/warningMapper';
import { ImageState } from 'editor/src/store/gallery/types';
import type { ThunkDispatch } from 'editor/src/store/hooks';
import { RootState } from 'editor/src/store/index';

import {
  getPersonalizationPricingSession,
  refreshPersonalizationPricing,
} from 'editor/src/util/personalizationPricing/runtime';
import sendPostMessage from 'editor/src/util/postMessages/sendPostMessage';

const sendDesignDataPostMessage =
  (checkConditionsAndFillMissing = true) =>
  (dispatch: ThunkDispatch, getState: () => RootState) => {
    const state = getState();
    refreshPersonalizationPricing({ getState });
    const personalizationPricingSession = getPersonalizationPricingSession({ getState });
    if (!personalizationPricingSession.canSubmit()) {
      sendPostMessage('personalization.configurationChanged', personalizationPricingSession.getState());
      return false;
    }
    const { images } = state.gallery;
    const addons = state.editorModules.addons.inUse;

    if (checkConditionsAndFillMissing) {
      if (images.find((image) => image.state !== ImageState.UPLOADED)) {
        // eslint-disable-next-line no-alert
        alert('Image upload in progress, please wait and try again later');
        return false;
      }
    }

    const extendedWarnings = state.design.designData ? calculateDesignDataWarnings(state.design.designData, state) : [];

    const designData = state.design.designData
      ? getDesignDataForExport(
          state.design.designData,
          images,
          addons,
          extendedWarningsToExportedWarnings(extendedWarnings),
        )
      : undefined;
    sendPostMessage('design.setDesignData', designData);
    return true;
  };

export default sendDesignDataPostMessage;
